import React from "react";
import { Rise, WordsRise } from "./Reveal";
import { useLang } from "../../lib/LangContext";

export default function Sustainability() {
  const { dict } = useLang();
  return (
    <section
      id="sustainability"
      data-testid="sustainability-section"
      className="relative bg-[#1A1918] text-[#F7F5F0] py-28 md:py-40 border-t hairline overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1543604502-9baac28067ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          mixBlendMode: "screen",
        }}
      />

      <div className="relative max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <span className="label" style={{ color: "#EAE6DF" }}>
              {dict.eco_kicker}
            </span>
          </div>
          <h2 className="col-span-12 md:col-span-9 serif font-light text-4xl md:text-6xl lg:text-7xl leading-[1] tracking-[-0.02em] max-w-[24ch]">
            <WordsRise text={dict.eco_title} />
          </h2>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {dict.eco_pillars.map((p, i) => (
            <Rise key={i} delay={i * 0.08}>
              <article className="col-span-12 md:col-span-4 border-t border-[#F7F5F0]/15 pt-8 pr-6 min-h-[220px]">
                <div className="flex items-baseline gap-4 mb-6">
                  <span className="serif italic text-3xl text-[#B56B45]">{p.n}</span>
                  <span className="label" style={{ color: "#EAE6DF" }}>
                    {dict.eco_pillar_label}
                  </span>
                </div>
                <h3 className="serif font-light text-3xl md:text-4xl leading-[1.05] tracking-tight mb-4">
                  {p.title}
                </h3>
                <p className="text-[15px] leading-[1.7] text-[#EAE6DF]/80 max-w-[36ch]">
                  {p.body}
                </p>
              </article>
            </Rise>
          ))}
        </div>
      </div>
    </section>
  );
}
